"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPlayUrls = void 0;
function toPlayUrls(adaptiveHlsUrl) {
    return {
        'hls.m3u8': adaptiveHlsUrl,
    };
}
exports.toPlayUrls = toPlayUrls;
//# sourceMappingURL=play-urls.js.map